<div class="strategy-outline">
  <div id="campaign-header" class="strategy-header main-white-panel">
    <div
      class="strategy-data-header"
      [ngStyle]="{
        'pointer-events': challengeStatus === 'ENDED' ? 'none' : 'auto'
      }"
    >
      <div *ngIf="challengeData">
        <div style="display: flex; justify-content: space-between">
          <div
            class="strategy-name-div"
            [matTooltip]="challengeData.challengeName"
            matTooltipClass="ex-tooltip-red1"
            matTooltipShowDelay="500"
          >
            <span>{{ challengeData.challengeName }}</span>
          </div>
          <button
            *ngIf="
              appSubscriptionPlan &&
              isChallengeInDraftStatus()
            "
            class="qb-disable-button-container"
            (click)="onEdit()"
            data-widget-name="CHALLENGE CANVAS"
            data-button-name="Modify"
            [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : 'Modify'"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
          >
            <svg
              width="17"
              height="18"
              viewBox="0 0 17 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.625 12.2812C1.75 11.8438 2 11.4375 2.3125 11.125L11.8125 1.625C12.5938 0.84375 13.875 0.84375 14.6562 1.625L15.875 2.84375C15.9688 2.9375 16.0625 3.0625 16.125 3.15625C16.6562 3.9375 16.5625 5 15.875 5.6875L6.375 15.1875C6.34375 15.2188 6.28125 15.25 6.25 15.3125C5.9375 15.5625 5.59375 15.75 5.21875 15.875L2.78125 16.5938L1.4375 17C1.1875 17.0625 0.90625 17 0.71875 16.7812C0.5 16.5938 0.4375 16.3125 0.53125 16.0625L0.90625 14.7188L1.625 12.2812ZM3.0625 12.7188L2.84375 13.4375L2.34375 15.1562L4.0625 14.6562L4.78125 14.4375C5 14.375 5.15625 14.2812 5.3125 14.125L12.4688 6.96875L10.5312 5.03125L3.375 12.1875C3.34375 12.1875 3.34375 12.2188 3.3125 12.25C3.1875 12.375 3.125 12.5312 3.0625 12.7188Z"
                fill="#4379EF"
              />
            </svg>
          </button>
        </div>
        <div style="display: flex; margin-top: 5px">
          <div style="max-width: 50%; gap: 10px" class="qb-d-flex">
            <div
              class="segment-name-container"
              *ngIf="challengeData.segments?.length > 0"
            >
              <span
                class="align-center-header"
                *ngFor="let segment of challengeData.segments; let i = index"
                style="min-width: fit-content"
                >{{ segment["segmentName"]
                }}<span *ngIf="i < challengeData.segments.length - 1"
                  >,&nbsp;</span
                ></span
              >
            </div>
            <div
              *ngIf="challengeData.challengeName && challengeData.allCustomer"
            >
              <span
                class="align-center-header"
                style="min-width: fit-content"
                >{{ "CAMPAIGN_PAGE.ALL_CUSTOMERS" | i18nTranslate }}</span
              >
            </div>
            <div *ngIf="challengeData.challengeName && challengeData.allLead">
              <span
                class="align-center-header"
                style="min-width: fit-content"
                >{{ "CAMPAIGN_PAGE.ALL_LEADS" | i18nTranslate }}</span
              >
            </div>
          </div>
          <span *ngIf="showMoreSegmentButtonStatus">...</span>
          <div
            *ngIf="showMoreSegmentButtonStatus"
            class="align-center-header more-segment-chevron"
          >
            <span
              (click)="showSegments($event)"
              class="chevron-icon-header align-center-header"
              data-widget-name="CANVAS"
              data-button-name="Show Segment"
              class="material-icons icons-primary chevron-icon"
            >
              double_arrow
            </span>
            <div class="segment-popup" id="segment-popup">
              <span
                style="padding: 5px 7px"
                *ngFor="let segment of challengeData.segments"
                >{{ segment["segmentName"] }}</span
              >
            </div>
          </div>
          <div class="header-seperator"></div>
          <div style="display: flex" class="align-center-header">
            <span class="material-icons-outlined person-icon icons-primary">
              person
            </span>
            <span style="margin-left: 5px; font-size: 13px">{{
              challengeData.customerCount
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="canvas-data-header"
      [ngStyle]="{
        'pointer-events': challengeStatus === 'ENDED' ? 'none' : 'auto'
      }"
    >
      <div>
        <div class="magnifier-container">
          <mat-icon
            class="undo-button"
            [ngClass]="{ disabled: zoomAmount === 30 }"
            (click)="magnify('SUB')"
            data-widget-name="CANVAS"
            data-button-name="Zoom out"
            >remove</mat-icon
          >
          <div class="magnify-text-container">
            <span class="magnify-text">{{ zoomAmount }}%</span>
          </div>
          <mat-icon
            class="redo-button"
            [ngClass]="{ disabled: zoomAmount === 150 }"
            (click)="magnify('ADD')"
            data-widget-name="CANVAS"
            data-button-name="Zoom in"
            >add</mat-icon
          >
        </div>
      </div>
      <!-- <div
        *ngIf="appSubscriptionPlan"
        (click)="resetCanvas()"
        class="reset-button-container"
        data-widget-name="CANVAS"
        data-button-name="Reset Canvas"
      >
        <mat-icon class="reset-button" style="border-radius: 5px"
          >refresh</mat-icon
        >
        <span style="margin-left: 5px">{{
          "CAMPAIGN_PAGE.RESET_CANVAS" | i18nTranslate
        }}</span>
      </div> -->
    </div>
    <div class="strategy-operation-header">
      <div [ngClass]="challengeStatus" class="status-text">
        <span
          class="material-icons icons-primary"
          style="color: inherit; font-size: 21px"
        >
          flag
        </span>
        <span style="color: inherit; font-size: 16px">{{
          challengeStatus | i18nDynamicTranslate : "POS_PAGE"
        }}</span>
      </div>
      <div *ngIf="!isCreatorOfChallenge()" class="view-only-container">
        <div
          class="material-symbols-outlined view-only-back"
          (click)="navigateBackToListing()"
        >
          arrow_back_ios
        </div>
        <div
          class="view-only"
          [matTooltip]="
            'No permission to edit Journey created by ' +
            this.challengeData?.created_by?.storeName
          "
        >
          view-only
        </div>
      </div>
      <div
        style="display: flex; gap: 10px; align-items: center"
        *ngIf="isCreatorOfChallenge()"
      >
        <button
          class="qb-disable-button-container"
          *ngIf="appSubscriptionPlan"
          [ngClass]="{ disabled: challengeStatus === 'ENDED' }"
          (click)="challengeStatus === 'ENDED' ? null : saveChallenge()"
          [matTooltip]="'Save and Exit'"
          [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
          [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('COMMON_PAGE.SAVE_EXIT' | i18nTranslate)"
          [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
          data-widget-name="CANVAS"
          data-button-name="Save and Exit"
          [style.cursor]="
            challengeStatus === 'ENDED' ? 'not-allowed' : ''
          "
          style="height: fit-content"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="28px"
            viewBox="0 -960 960 960"
            width="28px"
            [ngStyle]="{
              fill: challengeStatus === 'ENDED' ? '#989898' : '#4379EF'
            }"
          >
            <path
              d="M816-672v456q0 29.7-21.15 50.85Q773.7-144 744-144H216q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h456l144 144Zm-72 30L642-744H216v528h528v-426ZM480-252q45 0 76.5-31.5T588-360q0-45-31.5-76.5T480-468q-45 0-76.5 31.5T372-360q0 45 31.5 76.5T480-252ZM264-552h336v-144H264v144Zm-48-77v413-528 115Z"
            />
          </svg>
        </button>
        <button
          class="qb-disable-button-container"
          *ngIf="appSubscriptionPlan"
          (click)="onDelete()"
          [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
          [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('CAMPAIGN_PAGE.DELETE' | i18nTranslate)"
          [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
          data-widget-name="CANVAS"
          data-button-name="Delete"
          style="height: fit-content"
        >
          <svg
            width="22px"
            height="22px"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.03125 1.5C5.9375 1.5 5.875 1.5625 5.8125 1.625L5.21875 2.5H9.75L9.15625 1.625C9.125 1.5625 9.03125 1.5 8.9375 1.5H6.03125ZM11.5625 2.5H11.9688H13.5H13.75C14.1562 2.5 14.5 2.84375 14.5 3.25C14.5 3.6875 14.1562 4 13.75 4H13.375L12.625 14.1562C12.5312 15.2188 11.6875 16 10.625 16H4.34375C3.28125 16 2.4375 15.2188 2.34375 14.1562L1.59375 4H1.25C0.8125 4 0.5 3.6875 0.5 3.25C0.5 2.84375 0.8125 2.5 1.25 2.5H1.5H3H3.40625L4.5625 0.78125C4.875 0.3125 5.4375 0 6.03125 0H8.9375C9.53125 0 10.0938 0.3125 10.4062 0.78125L11.5625 2.5ZM11.875 4H3.09375L3.84375 14.0625C3.875 14.3125 4.09375 14.5 4.34375 14.5H10.625C10.875 14.5 11.0938 14.3125 11.125 14.0625L11.875 4Z"
              fill="#4379EF"
            />
          </svg>
        </button>
        <button
          class="secondary-button qb-secondary-outline"
          *ngIf="challengeStatus === 'DRAFT' && appSubscriptionPlan"
          [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
          [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ''"
          [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
          (click)="
            challengeStatus === 'ENDED' ||
            challengeStatus === 'SCHEDULED' ||
            challengeStatus === 'ACTIVE' ||
            challengeStatus === 'DEACTIVATED'
              ? null
              : createNewNode()
          "
        >
          <span> Add Node </span>
        </button>
        <button
          *ngIf="
            (challengeStatus === 'DRAFT' || challengeStatus === 'ENDED') &&
            appSubscriptionPlan
          "
          class="primary-button "
          [ngClass]="{
            'button-ended': challengeStatus === 'ENDED'
          }"
          (click)="challengeStatus === 'ENDED' ? null : activateStrategy()"
          [matTooltip]="
      
          "
          data-widget-name="CANVAS"

          [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
          [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ((challengeStatus === 'ENDED'
          ? 'Ended Challenge cant be activated'
          : ''
        ) | i18nDynamicTranslate : 'POS_PAGE')"
          [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 

          data-button-name="Activate Challenge"
          [style.cursor]="
            challengeStatus === 'ENDED' ? 'not-allowed' : 'pointer'
          "
        >
          <span>{{ "CAMPAIGN_PAGE.ACTIVATE" | i18nTranslate }}</span>
        </button>
        <button
          *ngIf="
            challengeStatus === 'ACTIVE' || challengeStatus === 'SCHEDULED'
          "

          [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
          [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('Deactivate Challenge')"
          [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 

          class="deactivate-button-header qb-disable-button-container"
          (click)="deactivateStrategy()"
          data-widget-name="CANVAS"
          data-button-name="Deactivate Challenge"
        >
          <span>Deactivate</span>
        </button>
      </div>
    </div>
  </div>
  <div class="strategy-container" id="strategy-container">
    <div class="canvas-container">
      <div class="canvas" id="canvas">
        <div class="qb-challenge-container challenge-node-block">
          <div class="qb-challenge-header">
            <div class="qb-d-flex qb-ai-center">
              <span
                class="material-icons-outlined node-header-icon icons-primary"
                >play_circle</span
              >
              <span>Challenge Config</span>
            </div>
            <button
            class="qb-disable-button-container"
            [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
            [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ''"
            [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
            [matMenuTriggerFor]="menuRef"
              *ngIf="
                !(
                  challengeStatus === 'ENDED' || challengeStatus === 'DEACTIVATED'
                )
              "
            >
              <mat-icon
                style="border-radius: 25px"
                class="node-config-icon"
                >more_vert</mat-icon
              >
            </button>

            <mat-menu #menuRef="matMenu">
              <button mat-menu-item (click)="onEdit()">
                <mat-icon>edit</mat-icon> Edit
              </button>
            </mat-menu>
          </div>
          <div class="qb-challenge-content">
            <div class="qb-challenge-group">
              <div class="qb-challenge-conditions">
                <div class="qb-challenge-condition-header">
                  <div>Challenge Details</div>
                  <div
                    class="trigger-condition-toggle"
                    id="keyboard_arrow_down"
                  >
                    <mat-icon
                      class="keyboard-down-icon"
                      (click)="challengeDetailsDownArrowClicked()"
                      >keyboard_arrow_down</mat-icon
                    >
                  </div>
                </div>
                <div
                  class="qb-challenge-condition-content"
                  id="challenge-config-details"
                >
                  <div *ngIf="getUsageConfiggDetails(challengeData?.usageConfig, 'participationLimit')">
                    Participation Limit : {{ getUsageConfiggDetails(challengeData?.usageConfig, 'participationLimit') }}
                  </div>
                  <div *ngIf="getUsageConfiggDetails(challengeData?.usageConfig, 'rejoinInDays')">
                    Rejoin in : {{ getUsageConfiggDetails(challengeData?.usageConfig, 'rejoinInDays') }} days
                  </div>
                  <div>
                    Date Range:
                    {{
                      (challengeData?.scheduledStartTime)
                        | date : getDateFormat("dd MMM yyyy")
                    }}
                    to
                    {{
                      (challengeData?.scheduledEndTime)
                        | date : getDateFormat("dd MMM yyyy")
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 40px">
          <div
            *ngFor="let data of milestoneData; let i = index; let isLast = last"
          >
            <div *ngIf="i !== 0" class="qb-connector-container">
              <div class="qb-connector"></div>
            </div>
            <div class="qb-challenge-container challenge-node-block">
              <div class="qb-challenge-header">
                <div class="qb-d-flex qb-ai-center qb-gap-8">
                  <span *ngIf="data.type === 'REWARDCONFIG'">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="20px"
                      viewBox="0 -960 960 960"
                      width="20px"
                      fill="#636466;"
                    >
                      <path
                        d="m363-310 117-71 117 71-31-133 104-90-137-11-53-126-53 126-137 11 104 90-31 133ZM480-28 346-160H160v-186L28-480l132-134v-186h186l134-132 134 132h186v186l132 134-132 134v186H614L480-28Zm0-112 100-100h140v-140l100-100-100-100v-140H580L480-820 380-720H240v140L140-480l100 100v140h140l100 100Zm0-340Z"
                      />
                    </svg>
                  </span>
                  <span *ngIf="data.type === 'MILESTONECONFIG'">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="20px"
                      viewBox="0 -960 960 960"
                      width="20px"
                      fill="#636466"
                    >
                      <path
                        d="M200-80v-760h640l-80 200 80 200H280v360h-80Zm80-440h442l-48-120 48-120H280v240Zm0 0v-240 240Z"
                      />
                    </svg>
                  </span>
                  <!-- <span
                    *ngIf="data.type === 'REWARDCONFIG'"
                    class="material-icons-outlined node-header-icon icons-primary"
                    >rewarded_ads</span
                  > -->

                  <span *ngIf="data.type === 'MILESTONECONFIG'"
                    >Milestone {{ data.milestoneCount }}</span
                  >
                  <span *ngIf="data.type === 'REWARDCONFIG'"> Reward</span>
                </div>
                <button
                  class="qb-disable-button-container"
                  [matMenuTriggerFor]="menuRef"
                  [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
                  [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ''"
                  [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
                  *ngIf="
                    !(
                      challengeStatus === 'ENDED' || challengeStatus === 'DEACTIVATED'
                    )
                  "
                >
                  <mat-icon
                    style="border-radius: 25px"
                    class="node-config-icon"
                    >more_vert</mat-icon
                  >
                </button>

                <mat-menu #menuRef="matMenu">
                  <button mat-menu-item (click)="onEdit(data)">
                    <mat-icon>edit</mat-icon> Edit
                  </button>
                  <button mat-menu-item (click)="onDelete(data)">
                    <mat-icon>delete</mat-icon> Delete
                  </button>
                </mat-menu>
              </div>
              <div *ngFor="let config of data.configData | keyvalue">
                <div
                  *ngIf="config.key === 'milestone' && config.value"
                  class="qb-challenge-content"
                >
                  <div class="qb-challenge-group">
                    <div class="qb-challenge-conditions">
                      <div class="qb-challenge-condition-header">
                        <div>Rules To Qualify</div>
                        <div
                          class="trigger-condition-toggle"
                          [id]="'keyboard_arrow_down-config' + i"
                        >
                          <mat-icon
                            class="keyboard-down-icon"
                            (click)="
                              milestoneDetailsDownArrowClicked(i, 'config')
                            "
                            >keyboard_arrow_down</mat-icon
                          >
                        </div>
                      </div>
                      <div
                        class="qb-challenge-condition-content"
                        [id]="'challenge-config-details-config' + i"
                      >
                        <app-logical-expressions-viewer
                          [logicalExpressions]="
                            config.value.milestoneconfig.barrier
                          "
                        ></app-logical-expressions-viewer>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  *ngIf="config.key === 'reward'"
                  class="qb-challenge-content"
                >
                  <div class="qb-challenge-group">
                    <div class="qb-challenge-conditions">
                      <div class="qb-challenge-condition-header">
                        <div>Reward Details</div>
                        <div
                          class="trigger-condition-toggle"
                          [id]="'keyboard_arrow_down-reward' + i"
                        >
                          <mat-icon
                            class="keyboard-down-icon"
                            (click)="
                              milestoneDetailsDownArrowClicked(i, 'reward')
                            "
                            >keyboard_arrow_down</mat-icon
                          >
                        </div>
                      </div>
                      <div
                        class="qb-challenge-condition-content"
                        [id]="'challenge-config-details-reward' + i"
                      >
                        <div *ngIf="config.value.rewardData == null || config.value.rewardData.length === 0">
                          No Reward Added
                        </div>
                        <div
                          class="qb-d-flex qb-fd-coloumn"
                          *ngIf="config.value.rewardData != null"
                        >
                          <div *ngFor="let reward of config.value.rewardData">
                            <div *ngIf="reward.type === 'LOYALTY_POINTS'">
                              <span> Reward {{ reward.value }} Points</span>
                            </div>
                            <div
                              class="qb-d-flex qb-fd-row"
                              *ngIf="
                                reward.type === 'OFFER' &&
                                reward.value.length > 0
                              "
                            >
                              <div>Award Offers:&nbsp;</div>
                              <div
                                style="max-width: 50%; gap: 10px"
                                class="qb-d-flex"
                              >
                                <div
                                  class="segment-name-container-challenge"
                                  *ngIf="reward.value?.length > 0"
                                >
                                  <span
                                    class="align-center-header"
                                    *ngFor="
                                      let offer of reward.value;
                                      let i = index
                                    "
                                    style="min-width: fit-content"
                                    >{{ offer["name"] | limitTo : 12 
                                    }}<span *ngIf="i < reward.value.length - 1"
                                      >,&nbsp;</span
                                    ></span
                                  >
                                </div>
                              </div>
                            </div>
                            <div
                              class="qb-d-flex qb-fd-row"
                              *ngIf="
                                reward.type === 'BADGE' &&
                                reward.value.length > 0
                              "
                            >
                              <div>Award Badges:&nbsp;</div>
                              <div
                                style="max-width: 50%; gap: 10px"
                                class="qb-d-flex"
                              >
                                <div
                                  class="segment-name-container-challenge"
                                  *ngIf="reward.value?.length > 0"
                                >
                                  <span
                                    class="align-center-header"
                                    *ngFor="let offer of reward.value"
                                    style="min-width: fit-content"
                                    >{{ offer["name"] | limitTo : 12
                                    }}<span *ngIf="i < reward.value.length - 1"
                                      >,&nbsp;</span
                                    ></span
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="isLast"
              class="qb-connector-container qb-d-flex qb-fd-coloumn qb-ai-center"
            >
              <div class="qb-connector"></div>
              <button
                class="qb-add-node-challenge qb-disable-button-container"
                id="add-button"
                (click)="
                  challengeStatus === 'ENDED' ||
                  challengeStatus === 'SCHEDULED' ||
                  challengeStatus === 'ACTIVE' ||
                  challengeStatus === 'DEACTIVATED'
                    ? null
                    : createNewNode()
                "
                [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
                [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : (challengeStatus === 'ENDED' ||
                challengeStatus === 'SCHEDULED' ||
                challengeStatus === 'ACTIVE' ||
                challengeStatus === 'DEACTIVATED') ? 'Cannot edit Active and Deactivated Challenge' : ''"
                [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')" 
              >
                <mat-icon class="add-node-icon">add</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- <div id="overlay"></div>
        <div id="notification-container"></div>
        <div id="notification" class="notification">
          <mat-icon class="notification-done-icon">done</mat-icon>
          <mat-icon class="notification-fail-icon">close</mat-icon>
          <span class="notificationn-content">{{'CAMPAIGN_PAGE.MESSAGE' | i18nTranslate}}</span>
          <mat-icon class="notification-close-icon">close</mat-icon>
        </div> -->
    </div>
  </div>
</div>
